var exports = {
  "u": "NativeDragRegion.module__nativeDragRegion___MWVQLW",
};

module.exports = exports;
